import { render, staticRenderFns } from "./template.vue?vue&type=template&id=33659d9c&scoped=true"
var script = {}
import style0 from "./template.vue?vue&type=style&index=0&id=33659d9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33659d9c",
  null
  
)

export default component.exports